/* eslint-disable no-use-before-define */
import axios from 'services/axios.wrapper';
import config from 'services/config';

const { apiServer } = config;
const accountUrl = `${apiServer}/ccp/v1/account`;
const authorizedUrl = `${accountUrl}/isauthorized`;

export default {
  getAccount,
  updateAccount,
  createAccount,
  isAuthorized
};

function getAccount() {
  const promise = axios.get(accountUrl);
  promise.catch(error => console.error(error));
  return promise;
}

function updateAccount(account) {
  const promise = axios.put(accountUrl, {
    Id: account.Id,
    Name: account.LegalName,
    TradeName: account.TradeName,
    Fbpn: account.FBPN,
    Email: account.Email,
    Phone: account.PhoneNumber,
    Address1: account.AddressLine,
    // Address2:
    City: account.City,
    State: account.State,
    ZipCode: account.ZipCode,
    IsProducer: account.IsProducer,
    CarrierAccounts: account.CarrierAccounts,
  });
  promise.catch(error => console.error(error));
  return promise;
}

function createAccount(account) {
  const promise = axios.post(accountUrl, {
    Name: account.accountName || '',
    Fbpn: account.fbpn.toUpperCase(),
    IsProducer: account.isProducer,
    HomeState: account.homeState,
    IsUnverifiedFbpn: account.isUnverifiedFbpn,
    CarrierAccounts: account.carrierAccounts
  });
  promise.catch(error => console.error(error));
  return promise;
}

function isAuthorized() {
  return axios.get(authorizedUrl);
}
